<div class="auth-flex-container">
  <div class="form-wrapper">
    <div class="form-header-wrapper">
      <h2 class="form-header-text">Unauthorized.</h2>
      <div>Your website user profile does not allow access to this page.</div>
      <div>If you have any questions, please contact Customer Care at 1-800-282-7648.</div>
    </div>
  </div>
</div>

